// import { Injectable } from '@angular/core';
import * as FileSaver from "file-saver";
import * as ExcelJS from "exceljs";

export class ExcelService {
  private EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  private EXCEL_EXTENSION = ".xlsx";

  public async exportAsExcelFile(
    worksheetData: any,
    excelFileName: string,
    sheetNames: any,
    useCaseName?: string
  ): Promise<void> {
    const workbook = new ExcelJS.Workbook();

    // Setting Up data
    const mainWorkSheetData = this.parseWorksheet(
      worksheetData.slice(1, worksheetData.length),
      useCaseName || ""
    );

    const overViewsheetData = this.parseWorksheetWithoutFormat(
      worksheetData.slice(0, 1)
    );

    const finalData = [...overViewsheetData, ...mainWorkSheetData];

    // Seting up Each Headers Row
    const mainHeaders = mainWorkSheetData.map((data: any) => {
      const ele = data;
      if (ele.length > 0) {
        const eleKeys = Object.keys(ele[0]);
        return eleKeys.map((key: any) => {
          return { header: key, key: key };
        });
      }
      return [];
    });

    const overViewHeaders = overViewsheetData.map((data: any) => {
      const ele = data;
      if (ele.length > 0) {
        const eleKeys = Object.keys(ele[0]);
        return eleKeys.map((key: any) => {
          return { header: key, key: key };
        });
      }
      return [];
    });

    const finalHeader = [...overViewHeaders, ...mainHeaders];
    let uniqueSheetNames: any = [];
    sheetNames.map((item: string) => {
      if (!uniqueSheetNames.includes(item)) {
        uniqueSheetNames.push(item);
      } else {
        uniqueSheetNames.push(item.trim() + "_");
      }
    });
    //Setting up Each worksheet
    const workSheets = uniqueSheetNames.map((element: any) => {
      return workbook.addWorksheet(element);
    });

    // Assigning headers to each sheets
    workSheets.forEach((sheet: any, i: number) => {
      sheet.columns = finalHeader[i];
      sheet.getRow(1).font = { bold: true };
    });

    //Adding Rows for Each Worksheets
    workSheets.forEach((sheet: any, i: number) => {
      finalData[i].forEach((data: any) => {
        sheet.addRow(data);
      });

      // Setting column width equal to content
      sheet.columns.forEach(function (column: any, i: number) {
        var maxLength = 0;
        column["eachCell"]({ includeEmpty: true }, function (cell: any) {
          var columnLength = cell.value ? cell.value.toString().length : 10;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
        });
        column.width = maxLength < 10 ? 10 : maxLength + 2;
      });
    });

    // Saving
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();
      this.saveAsExcelFile(excelBuffer, excelFileName);
    } catch (err) {
      console.log(err);
    }
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + this.EXCEL_EXTENSION);
  }

  private parseWorksheet(worksheetData: any, useCaseName: string) {
    let keyNames: any = [];
    return worksheetData.map((record: any) => {
      return record.map((item: any) => {
        if (useCaseName !== "Injection PdM") {
          return {
            Description: item[Object.keys(item)[0]],
            Timestamp: item[Object.keys(item)[4]],
            Value: item[Object.keys(item)[5]],
            // "Document No.": record.documentNumber,
            // "Account Type": record.accountType,
            // "Account No.": record.accountNumber,
            // Amount: record.amount,
            // "Currency Code": record.currencycode,
            // // Description: record.description,
            // "Bal. Account Type": record.balAccountType,
            // "Bal. Account No.": record.balAccountNumber,
            // "External Document No.": record.externalDocumentNumber,
            // Department: record.department,
            // Fund: record.fund,
            // Misc: record.misc,
            // Office: record.office,
            // Investment: record.investment,
            // Tax: record.tax,
            // IT: record.IT,
            // Project: record.project,
            // End: record.ending,
          };
        } else {
          if (keyNames.length === 0) {
            const keysArray = Object.keys(item);
            const descriptionKey = keysArray.find((key: string) =>
              key.includes("description")
            );
            const timeStampKey = keysArray.find((key: string) =>
              key.includes("timestamp")
            );
            const valueKey = keysArray.find((key: string) =>
              key.includes("lastValue")
            );
            keyNames = [descriptionKey, timeStampKey, valueKey];
          }
          return {
            Description: item[keyNames[0]],
            Timestamp: item[keyNames[1]],
            Value: item[keyNames[2]],
          };
        }
      });
    });
  }

  private parseWorksheetWithoutFormat(worksheetData: any) {
    return worksheetData.map((record: any) => {
      return record.map((item: any) => {
        return item;
      });
    });
  }
}
